import { useCallback } from 'react'
import { useAppSelector } from '../../app/typedReduxHooks'
import {
  isPrescribingTargetAllowed,
  selectIsEhrPrescribingAuthorized,
} from './ehrPatientAcquisitionSlice'

export const useCanPrescribeFor = () => {
  const provider = useAppSelector((state) => state.authenticatedProvider)
  const isEhrPrescribingAuthorized = useAppSelector(selectIsEhrPrescribingAuthorized)
  const ehrBoundPatientId = useAppSelector(
    (state) => state.ehrPatientAcquisition.binding?.patientId
  )

  return useCallback(
    (patientId: string) =>
      isPrescribingTargetAllowed(
        provider,
        isEhrPrescribingAuthorized,
        ehrBoundPatientId,
        patientId
      ),
    [ehrBoundPatientId, isEhrPrescribingAuthorized, provider]
  )
}
